import React from 'react';
import { Card, CardContent, CardActions, Button, CardMedia, Typography, useTheme, useMediaQuery, Box } from '@mui/material';
import { styled } from '@mui/system';

import defaultDam from '../../imgs/defaultDam.svg';
import defaulCompany from '../../imgs/dafaultCompany.svg';


const NpgbStatusText = styled(Typography)<{ status: 'Alerta' | 'Emergencia' | 'Normal' | 'Atencao' }>(({ theme, status }) => ({
  fontWeight: 'bold',
  color:
    status === 'Alerta'
      ? '#FF5C00'
      : status === 'Emergencia'
        ? '#ff0000' 
        : status === 'Atencao'
          ? '#b3b028'
          : theme.palette.text.primary,
}));

type ReusableCardProps = {
  imageUrl: string | undefined;
  altText?: string;
  title: string;
  subtitle?: string;
  button1Label?: string;
  button2Label?: string;
  onButton1Click?: () => void;
  onButton2Click?: () => void;
  labelAtt?: boolean;
  company: boolean;
  npgbText?: 'Alerta' | 'Emergencia' | 'Normal' | string;
  actionPlanText?: string;
  // hasViewPermission?: boolean;
  hasDashPermission?: boolean;
};

export const VCard: React.FC<ReusableCardProps> = ({
  imageUrl,
  altText,
  title,
  subtitle,
  button1Label,
  button2Label,
  onButton1Click,
  onButton2Click,
  labelAtt = true,
  company,
  npgbText,
  actionPlanText,
  // hasViewPermission = false,
  hasDashPermission = false,
}) => {

  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const npgbTextForDisplay = npgbText ? npgbText.replace(/"/g, '').trim() : undefined;

  const npgbTextForComparison = npgbText
    ? npgbTextForDisplay?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    : undefined;

  const npgbDisplayStatus: 'Alerta' | 'Emergencia' | 'Normal' | 'Atencao' = (() => {
    switch (npgbTextForComparison) {
      case 'Alerta':
        return 'Alerta';
      case 'Emergencia':
        return 'Emergencia';
      case 'Normal':
        return 'Normal';
      case 'Atencao':
        return 'Atencao';
      default:
        return 'Normal';
    }
  })();

  return (
    <Card sx={{ borderRadius: 5, backgroundColor: '#e2e1e1' }}>
      {imageUrl == null || imageUrl == undefined ?
        company ? <CardMedia component="img" alt={altText} image={defaulCompany} sx={{ height: smDown ? 150 : 300, objectFit: smDown ? 'contain' : 'fill', backgroundColor: 'white' }} /> : <CardMedia component="img" alt={altText} image={defaultDam} sx={{ height: smDown ? 150 : 300, objectFit: smDown ? 'contain' : 'fill', backgroundColor: 'white' }} />
        : <CardMedia component="img" alt={altText} src={`data:image/jpeg;base64, ${imageUrl}`} sx={{ height: smDown ? 150 : 300, backgroundColor: 'white', objectFit: smDown ? 'contain' : 'fill' }} />
      }
      <CardContent>
        <Typography variant="h5" component="div" marginBottom={'5px'}>
          {title}
        </Typography>
        {labelAtt &&
          <div>
            <Typography variant="subtitle2">Última atualização</Typography>
            <Typography variant="subtitle1" marginBottom={'-15px'}>{subtitle}</Typography>
          </div>
        }

        {npgbTextForDisplay && (
          <Box marginTop={2} display="flex" alignItems="center">
            <Typography variant="subtitle2" sx={{ marginRight: 0.5 }}>NPGB:</Typography>
            <NpgbStatusText variant="subtitle2" status={npgbDisplayStatus}>
              {npgbTextForDisplay}
            </NpgbStatusText>
          </Box>
        )}

        {actionPlanText && (
          <Box marginTop={1} display="flex" alignItems="center">
            <Typography variant="subtitle2" sx={{ marginRight: 0.5 }}>Plano de Ação:</Typography>
            <Typography variant="subtitle2">{actionPlanText}</Typography>
          </Box>
        )}

      </CardContent>
      <CardActions >
        <Button onClick={onButton1Click} variant='text' color='primary'
          // disabled={!hasViewPermission}
        >
          {button1Label}
        </Button>
        <Button onClick={onButton2Click} variant='text' color='primary' disabled={!hasDashPermission}>{button2Label}</Button>
      </CardActions>
    </Card>
  );
};